import { useState } from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", label: "EN", flag: "English" },
  { code: "fr", label: "FR", flag: "Français" },
  { code: "da", label: "DA", flag: "Dansk" },
  { code: "de", label: "DE", flag: "Deutsch" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = languages.find((l) => l.code === i18n.language) ?? languages[0];

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-3 py-2 text-sm font-semibold text-foreground-700 cursor-pointer hover:bg-background-100 transition-colors"
      >
        <span className="flex w-4 h-4 items-center justify-center">
          <i className="ri-global-line text-sm"></i>
        </span>
        {current.label}
        <span className="flex w-4 h-4 items-center justify-center">
          <i className="ri-arrow-down-s-line text-sm"></i>
        </span>
      </button>

      {open && (
        <div className="absolute right-0 top-full z-50 mt-2 w-40 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {languages.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => {
                i18n.changeLanguage(l.code);
                setOpen(false);
              }}
              className={`flex w-full items-center justify-between px-4 py-2.5 text-left text-sm whitespace-nowrap cursor-pointer transition-colors hover:bg-background-100 ${
                l.code === current.code ? "font-semibold text-primary-600" : "text-foreground-700"
              }`}
            >
              <span>{l.flag}</span>
              <span className="text-xs text-foreground-500">{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}